// users

import http from '../../../store/api/http' 

const actions = {
    getUsers(context, param) {
    	console.log('action->getUsers')
    	let query = '?page=' + param.page
    	query += '&sortby=' + (param.sortBy ? param.sortBy : '')
    	query += '&sortdir=' + (param.sortDesc ? param.sortDesc : 'asc')
    	query += '&filter=' + param.filter
    	query += '&paginate=yes'
		return new Promise((resolve, reject) => {
			http.get('/api/users' + query)
			.then(function (response) {
		    	if(typeof(response.data) === 'object' && response.data.data instanceof Array) {
		    		context.commit('getUsers', response.data.data)
		    	} else reject(error)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    editUser(context, data) {
    	console.log('action->editUser')
		return new Promise((resolve, reject) => {
			http.get('/api/users/' + data + '/edit')
			.then(function (response) {
		    	context.commit('getUser', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    createUser(context, data) {
    	console.log('action->createUser')
		return new Promise((resolve, reject) => {
			http.post('/api/users', data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    updateUser(context, data) {
    	console.log('action->updateUser')
		return new Promise((resolve, reject) => {
			http.patch('/api/users/' + data.id, data)
			.then(function (response) {
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    storeUser(context, data) {
    	console.log('action->storeUser')
		return new Promise((resolve, reject) => {
			context.dispatch(data.id>0 ? 'updateUser' : 'createUser', data)
      		.then((response) => {
				resolve(response)
  			})
	    	.catch((error) => {
				reject(error)
		    });
		})
    },
    getRoles(context, param) {
    	console.log('action->getRoles')
		return new Promise((resolve, reject) => {
			http.get('/api/roles')
			.then(function (response) {
		    	context.commit('getRoles', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },
    getTeams(context, param) {
    	console.log('action->getTeams')
		return new Promise((resolve, reject) => {
			http.get('/api/teams')
			.then(function (response) {
		    	context.commit('getTeams', response.data)
				resolve(response)
			})
			.catch(function (error) {
				console.log(error)
				reject(error)
			});
		})
    },

};

export default actions;